import { FunctionComponent } from 'react'
import { Chip } from '@black-bear-energy/rucksack'
import { ErrorOutlineRounded } from '@mui/icons-material'
import { DocumentRequirement } from '@black-bear-energy/black-bear-energy-common'
import { rucksack } from '@black-bear-energy/rucksack'

export const UploadStatusChip: FunctionComponent<UploadStatusChipProps> = ({
  document,
}) => {
  let statusLabel: string
  let statusSx: {
    color?: string
    backgroundColor?: string
  }
  let chipIcon = undefined

  const isRejected =
    document.review && !document.review.outdated && !document.review.verified

  if (!document.uploaded) {
    return null
  }

  if (isRejected) {
    statusLabel = 'Rejected'
    statusSx = {
      backgroundColor: rucksack.palette.error.chipFill,
      color: rucksack.palette.error.chipLabel,
    }
    chipIcon = (
      <ErrorOutlineRounded
        style={{ color: rucksack.palette.error.chipLabel }}
      />
    )
  } else {
    statusLabel = 'Uploaded'
    statusSx = {
      backgroundColor: rucksack.palette.success.chipFill,
      color: rucksack.palette.success.chipLabel,
    }
  }

  return (
    <Chip
      icon={chipIcon}
      label={statusLabel}
      size="small"
      sx={{ ...statusSx, height: '18px' }}
    />
  )
}

interface UploadStatusChipProps {
  document: DocumentRequirement
}
